/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Proof_2_VInputs */

const en_mk_proof_2_v = /** @type {(inputs: Mk_Proof_2_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In your browser`)
};

const id_mk_proof_2_v = /** @type {(inputs: Mk_Proof_2_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lewat browser`)
};

/**
* | output |
* | --- |
* | "In your browser" |
*
* @param {Mk_Proof_2_VInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_proof_2_v = /** @type {((inputs?: Mk_Proof_2_VInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Proof_2_VInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_proof_2_v(inputs)
	return en_mk_proof_2_v(inputs)
});